module.exports = __webpack_public_path__ + "static/media/md-power.2ab627e8.svg";